import { api } from "api/apiService";

const baseUrl = "/api-tokens";

/**
 * Завантажує активні API-токени поточного користувача.
 * Відповідає ендпоінту: GET /api-tokens
 * @returns {Promise<Array>} Масив токенів без секретної частини.
 */
export const fetchTokens = () => {
  return api.get(baseUrl);
};

/**
 * Створює новий API-токен. Сирий токен присутній лише в цій відповіді.
 * Відповідає ендпоінту: POST /api-tokens
 * @param {string} name - Назва токена.
 * @returns {Promise<object>} Створений токен разом із полем token.
 */
export const createToken = (name) => {
  return api.post(baseUrl, { name });
};

/**
 * Відкликає API-токен.
 * Відповідає ендпоінту: DELETE /api-tokens/:id
 * @param {number} tokenId - ID токена.
 */
export const revokeToken = (tokenId) => {
  return api.delete(`${baseUrl}/${encodeURIComponent(tokenId)}`);
};

/**
 * Завантажує документацію API у вигляді JSON для рендеру на сторінці.
 * Відповідає ендпоінту: GET /api-tokens/docs
 */
export const fetchDocs = () => {
  return api.get(`${baseUrl}/docs`);
};

/**
 * Завантажує документацію API у форматі Markdown (для агентів і скриптів).
 * Відповідає ендпоінту: GET /api-tokens/docs?format=md
 * @returns {Promise<string>} Текст Markdown.
 */
export const fetchDocsMarkdown = async () => {
  const blob = await api.get(`${baseUrl}/docs`, { format: "md" }, { responseType: "blob" });
  return blob.text();
};
